// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__MPGel","topBottomGutter":"Layout_topBottomGutter__2HXGc"};